import { Type } from '@uswitch/spark'

const LinkListItem = ({ href, ...rest }) => (
  <li
    sx={{
      color: ['grey-100', null, 'grey-80'],
      marginBottom: '16px',
      '&::after': {
        content: '"|"',
        color: 'grey-60',
      },
      '&:last-of-type::after': {
        content: '""',
      },
    }}
    {...rest}
  >
    <Type.Hyperlink1
      sx={{
        marginX: '16px',
        color: ['grey-100', null, 'grey-80'],
      }}
      as={'a'}
      href={href}
      {...rest}
    />
  </li>
)

export default LinkListItem
